import React from "react";
import ReactDOM from "react-dom/client";
// Polyfill MUST run BEFORE React initializes — patches Node.removeChild/insertBefore
// to survive Google Translate's DOM mutations. See file for details.
import "./i18n/reactGoogleTranslatePolyfill";
import "@/index.css";
import "./i18n";
import { initGermanBusinessLingo } from "./i18n/germanBusinessLingo";
import App from "@/App";

// Rewrite Google Translate's awkward German into proper recruitment German.
initGermanBusinessLingo();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />,
);
